import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { BsModalRef } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { DesignphotoService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditdesignStock.html",
})
export class AddEditDesignStock {
  @Output() partyUpdateEvent = new EventEmitter();
  row: any;
  data: any = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  printPreview = [];
  res1: any;
  designList = [];
  box_print: string;
  typeList = ["Fresh", "Damage"];
  mode: string;
  saveEvent: any;
  agentList: any;
  sample: boolean;
  noofpcs: number;
  partyCodeList: any;
  box: boolean;
  shirt: boolean;
  isLoading: boolean = false;
  userTypeList = [{ type: "ADMIN" }, { type: "USER" }];
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  stockdata: any = [];
  @Input() set stkdata(val: any) {
    this.stockdata = val;
    this.stockdata.mfg_date = this.datePipe.transform(
      this.stockdata.mfg_date,
      "yyyy-MM-dd"
    );
    this.stockdata.act_mfg_date = this.datePipe.transform(
      this.stockdata.act_mfg_date,
      "yyyy-MM-dd"
    );
  }
  @Input() set stock(val: any) {
    this.data = val;
  }
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("statusAuto") statusAuto;
  @ViewChild("shiftauto") shiftauto;
  shiftCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private designService: DesignphotoService
  ) {
    this.sample = false;
    // this.mode = this.stockdata.mode;
  }
  ngOnInit() {
    this.getDesignNoList();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#design_num").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (
      nextEl == "f36" ||
      "f38" ||
      "f40" ||
      "f42" ||
      "f44" ||
      "f46" ||
      "h36" ||
      "h38" ||
      "h40" ||
      "h42" ||
      "h44" ||
      "h46"
    ) {
      $("#" + nextEl).select();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onSelectColor(id) {
    this.stockdata.design_id = id;
    $("#stocktype").focus();
  }

  onSelectdesign($event) {
    let params = {
      des_id: $event.item.des_id,
      design_no: $event.item.design_no,
      design_id: $event.item.design_id,
    };
    this.stockdata.des_id = $event.item.des_id;
    this.designService.getDesignColorList1(params).then((res: any) => {
      this.colorList = res;
      $("#code").focus();
    });
  }

  calcTot() {
    this.stockdata.fqty =
      this.stockdata.f36 +
      this.stockdata.f38 +
      this.stockdata.f40 +
      this.stockdata.f42 +
      this.stockdata.f44 +
      this.stockdata.f46;
    this.stockdata.hqty =
      this.stockdata.h36 +
      this.stockdata.h38 +
      this.stockdata.h40 +
      this.stockdata.h42 +
      this.stockdata.h44 +
      this.stockdata.h46;
    this.stockdata.totqty = this.stockdata.fqty + this.stockdata.hqty;
  }

  getDesignNoList() {
    this.designService.getDesignNoList({}).then((res: any) => {
      this.designList = res;
    });
  }
  printdata() {
    // this.bsModalRef.hide();
    // if(box_print == 'BOX'){
    //     this.noofpcs = 2;
    // }else if(box_print == 'SHIRT'){
    //     this.noofpcs = 1;
    // }
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
      $("#printpr").modal("hide");
      this.bsModalRef.hide();
      let data = this.res1;

      let params = {
        export: this.stockdata.export,
        noofpcs: this.noofpcs,
        designdet: JSON.stringify(data),
        box: this.box,
        shirt: this.shirt,
      };
      this.designService.print1(params);
    }
  }
  closeModal() {
    this.bsModalRef.hide();
  }
  checkSample() {
    if (this.sample == true && !this.stockdata.sample_no) {
      swal("Enter the Sample No!");
    } else {
      let params = {
        sample_no: this.stockdata.sample_no,
      };
      let that = this;
      this.designService.checkSample(params).then(function (res: any) {
        let sample = res.data.sample_no;
        if (!sample) {
          that.onSaveStock();
        } else {
          let barcode = ("0000000" + res.data.barcode).slice(-7);
          swal("SAMPLE.NO ALREADY EXISTS ON " + barcode);
          return false;
        }
      });
    }
  }

  onSaveStock() {
    if (this.sample) {
      if (this.stockdata.totqty > 1) {
        swal("Shirt stock should not be greater than 1");
        return false;
      }
    }
    if (this.stockdata.design_no == "") {
      swal("Enter the Design No!");
    } else if (this.stockdata.code == "") {
      swal("Enter the Design Color!");
    } else if (this.sample == true && !this.stockdata.sample_no) {
      swal("Enter the Sample No!");
    } else {
      let that = this;
      let params = Object.assign({}, this.stockdata);
      params["mfg_date"] = this.datePipe.transform(
        params["mfg_date"],
        "yyyy-MM-dd"
      );
      params["act_mfg_date"] = this.datePipe.transform(
        params["act_mfg_date"],
        "yyyy-MM-dd"
      );

      this.isLoading = true;
      this.designService
        .addDesignStock(params)
        .then(function (res: any) {
          let data = res.printData;
          that.isLoading = false;
          if (res.success) {
            that.res1 = res.printData;
            that.printPreview = res.printData;
            $("#printpr").modal("show");
            that.stockdata = {
              userid: "",
              username: "",
              password: "",
              fullname: "",
              address: "",
              phone: "",
              email: "",
              usertype: "",
              doj: "",
              status: "",
              designation: "",
            };

            // that.printdata(data);

            that.partyUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            // that.bsModalRef.hide();
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/DesignStock/addEditdesignStock.ts